function generateIdFromName(name) {
    return name.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
}


const productosLambrin = [

    {
        nombre: 'Lambrin Jatoba',
        colores: ['Jatoba', 'Esquineros', 'Clips para instalación'],
        categoria: 'Lambrin',
        tipo: 'Interior',
        largo: '1.15 m y 2.65 m',
        ancho: '16 cm',
        altura: '23 mm',
        images: [
            require("../../assets/img/productos/lambrin/1.jpg"),
            require("../../assets/img/productos/lambrin/1.jpg"),
            require("../../assets/img/productos/lambrin/7.png"),
            require("../../assets/img/productos/lambrin/8.png")
        ]
    },
    {
        nombre: 'Lambrin Pino',
        colores: ['Pino', 'Esquineros', 'Clips para instalación'],
        categoria: 'Lambrin',
        tipo: 'Interior',
        largo: '1.15 m y 2.65 m',
        ancho: '16 cm',
        altura: '23 mm',
        images: [
            require("../../assets/img/productos/lambrin/2.jpg"),
            require("../../assets/img/productos/lambrin/2.jpg"),
            require("../../assets/img/productos/lambrin/7.png"),
            require("../../assets/img/productos/lambrin/8.png")
        ]
    },
    {
        nombre: 'Lambrin Roble',
        colores: ['Roble', 'Esquineros', 'Clips para instalación'],
        categoria: 'Lambrin',
        tipo: 'Interior',
        largo: '1.15 m y 2.65 m',
        ancho: '16 cm',
        altura: '23 mm',
        images: [
            require("../../assets/img/productos/lambrin/3.jpg"),
            require("../../assets/img/productos/lambrin/3.jpg"),
            require("../../assets/img/productos/lambrin/7.png"),
            require("../../assets/img/productos/lambrin/8.png")
        ]
    },
    {
        nombre: 'Lambrin Nogal',
        colores: ['Nogal', 'Esquineros', 'Clips para instalación'],
        categoria: 'Lambrin',
        tipo: 'Interior',
        largo: '2.90 m',
        ancho: '16 cm',
        altura: '23 mm',
        images: [
            require("../../assets/img/productos/lambrin/4.jpg"),
            require("../../assets/img/productos/lambrin/4.jpg"),
            require("../../assets/img/productos/lambrin/7.png"),
            require("../../assets/img/productos/lambrin/8.png")
        ]
    },
    {
        nombre: 'Lambrin Arce',
        colores: ['Arce', 'Esquineros', 'Clips para instalación'],
        categoria: 'Lambrin',
        tipo: 'Interior',
        largo: '2.90 m',
        ancho: '16 cm',
        altura: '23 mm',
        images: [
            require("../../assets/img/productos/lambrin/5.jpg"),
            require("../../assets/img/productos/lambrin/5.jpg"),
            require("../../assets/img/productos/lambrin/7.png"),
            require("../../assets/img/productos/lambrin/8.png")
        ]
    },
    {
        nombre: 'Lambrin Ébano',
        colores: ['Ébano', 'Esquineros', 'Clips para instalación'],
        categoria: 'Lambrin',
        tipo: 'Interior',
        largo: '2.90 m',
        ancho: '16 cm',
        altura: '23 mm',
        images: [
            require("../../assets/img/productos/lambrin/6.jpg"),
            require("../../assets/img/productos/lambrin/6.jpg"),
            require("../../assets/img/productos/lambrin/7.png"),
            require("../../assets/img/productos/lambrin/8.png")
        ]
    },
    {
        nombre: 'Lambrin Onix',
        colores: ['Onix', 'Muestra', 'Esquineros', 'Clips para instalación'],
        categoria: 'Lambrin',
        tipo: 'Interior',
        largo: '2.90 m',
        ancho: '16 cm',
        altura: '23 mm',
        images: [
            require("../../assets/img/productos/lambrin/onix.jpg"),
            require("../../assets/img/productos/lambrin/onix.jpg"),
            require("../../assets/img/productos/lambrin/onix-1.jpg"),
            require("../../assets/img/productos/lambrin/7.png"),
            require("../../assets/img/productos/lambrin/8.png")
        ]
    },
    {
        nombre: 'Lambrin Basalto',
        colores: ['Basalto', 'Muestra', 'Esquineros', 'Clips para instalación'],
        categoria: 'Lambrin',
        tipo: 'Interior',
        largo: '2.90 m',
        ancho: '16 cm',
        altura: '23 mm',
        images: [
            require("../../assets/img/productos/lambrin/basalto.jpg"),
            require("../../assets/img/productos/lambrin/basalto.jpg"),
            require("../../assets/img/productos/lambrin/basalto-1.jpg"),
            require("../../assets/img/productos/lambrin/7.png"),
            require("../../assets/img/productos/lambrin/8.png")
        ]
    },{
        nombre: 'Lambrin Teca',
        colores: ['Teca', 'Muestra', 'Esquineros', 'Clips para instalación'],
        categoria: 'Lambrin',
        tipo: 'Interior',
        largo: '2.90 m',
        ancho: '16 cm',
        altura: '23 mm',
        images: [
            require("../../assets/img/productos/lambrin/teca.jpg"),
            require("../../assets/img/productos/lambrin/teca.jpg"),
            require("../../assets/img/productos/lambrin/teca-1.jpg"),
            require("../../assets/img/productos/lambrin/7.png"),
            require("../../assets/img/productos/lambrin/8.png")
        ]
    },
].map(producto => ({
    ...producto,
    id: generateIdFromName(producto.nombre),
    slug: `${producto.nombre.toLowerCase().replace(/\s+/g, '-')}-${producto.categoria.toLowerCase().replace(/\s+/g, '-')}`
}));

export default productosLambrin;